var BaseView = require('../../../components/accordion-list/content');
var ColorThumbnailView = require('../../../components/thumbnail/color');
var AnalyticsDecorate = require('../../../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('../../analytics/stickers'), BaseView.extend({
  apiCall: 'search/stickers',
  dataName: 'stickerCategories',
  callbackName: 'callbackStickers',
  where: {},

  initialize: function (options) {
    this.category = _.find(INKIVE.Tool._cache['stickerCategories'], function (category) {
      return category.id == options.key;
    });

    BaseView.prototype.initialize.call(this, options);
  },

  getScrollHeight: function ($target) {
    return $target.closest('.tab-content').height() - this.$el.siblings().height();
  },

  getParams: function () {
    var params = {
      from: this.from,
      limit: this.limit,
      where: { category: this.category.name, active: INKIVE.C.USER.IS_SUPER ? 0 : 1 }
    };

    this.from += this.limit;

    return params;
  },

  extractData: function (data) {
    return _.map(data, function (item) {
      return {
        id: 'sticker-' + item['id'],
        src: item['url'],
        width: item['width'],
        height: item['height'],
        cls: parseInt(item['active']) ? '' : ' grayscale',
        data: {
          name: item['name'],
          count: item['count'],
          changeable: item['changeable'],
          width: item['width'],
          height: item['height']
        }
      };
    });
  }
}));
